import { Identifiable } from './identifiable';
import { Assessment } from './assessment';

export class AssessmentDistribution implements Identifiable {
  id: string;
  sendDate: Date;
  riskAssessment: Assessment;
}
